import { useState } from "react";
import { useNavigate } from "react-router-dom";
import DiagonalLines from "@/components/feature/DiagonalLines";

const footerNav = [
  {
    en: "SERVICE",
    ja: "サービス",
    items: [
      { label: "ホームページ制作", path: "/service" },
      { label: "SEO対策", path: "/service" },
      { label: "MEO対策", path: "/service" },
      { label: "LLMO対策", path: "/service" },
      { label: "自社アプリ制作", path: "/service" },
      { label: "リスティング広告", path: "/service" },
      { label: "SNS広告・インフルエンサー", path: "/service" },
    ],
  },
  {
    en: "STRENGTH",
    ja: "クラプリックスの強み",
    items: [{ label: "クラプリックスの強み", path: "/strength" }],
  },
  {
    en: "FLOW",
    ja: "ご相談の流れ",
    items: [{ label: "ご相談の流れ", path: "/flow" }],
  },
  {
    en: "FAQ",
    ja: "よくある質問",
    items: [{ label: "よくある質問", path: "/faq" }],
  },
  {
    en: "DIAGNOSIS",
    ja: "無料診断",
    items: [
      { label: "無料診断", path: "/diagnosis" },
    ],
  },
  {
    en: "CONTACT",
    ja: "お問い合わせ",
    items: [
      { label: "お問い合わせ", path: "/contact" },
    ],
  },
  {
    en: "COMPANY",
    ja: "会社情報",
    items: [
      { label: "会社情報", path: "/company" },
    ],
  },
];

const legalContents: Record<string, { title: string; body: string[] }> = {
  プライバシーポリシー: {
    title: "プライバシーポリシー",
    body: [
      "株式会社クラプリックス（以下「当社」）は、お客様の個人情報の保護を重要な責務と認識し、以下の方針に基づき適切に取り扱います。",
      "1. 取得する個人情報\nお問い合わせ・ご相談の際に、氏名・会社名・電話番号・メールアドレス等の個人情報をご提供いただく場合があります。",
      "2. 利用目的\n取得した個人情報は、以下の目的のためにのみ使用します。\n・お問い合わせ・ご相談への回答\n・サービスのご案内・ご提案\n・契約の締結・履行",
      "3. 第三者提供\n法令に基づく場合を除き、お客様の同意なく第三者に個人情報を提供することはありません。",
      "4. 個人情報の管理\n個人情報への不正アクセス・紛失・破損・改ざん・漏洩を防止するため、適切な安全管理措置を講じます。",
      "5. 個人情報の開示・訂正・削除\nお客様ご本人から個人情報の開示・訂正・削除のご請求があった場合、合理的な範囲で速やかに対応します。",
      "6. お問い合わせ窓口\n個人情報の取り扱いに関するお問い合わせは、下記までご連絡ください。\n株式会社クラプリックス　個人情報管理担当",
      "7. 法令の遵守\n当社は、個人情報保護法およびその他関連法令を遵守します。",
    ],
  },
  利用規約: {
    title: "利用規約",
    body: [
      "本規約は、株式会社クラプリックス（以下「当社」）が提供するサービスの利用条件を定めるものです。",
      "1. 適用範囲\n本規約は、当社のWebサイトおよびサービスを利用するすべてのお客様に適用されます。",
      "2. 禁止事項\nお客様は以下の行為を行ってはなりません。\n・法令または公序良俗に違反する行為\n・当社または第三者の権利・利益を侵害する行為\n・当社サービスの運営を妨害する行為\n・虚偽の情報を提供する行為\n・その他当社が不適切と判断する行為",
      "3. 知的財産権\n当社Webサイト上のコンテンツ（文章・画像・デザイン等）の著作権は当社に帰属します。無断転載・複製を禁じます。",
      "4. 免責事項\n当社は、当社サービスに関連してお客様に生じた損害について、当社の故意または重大な過失による場合を除き、責任を負いません。",
      "5. 規約の変更\n当社は必要に応じて本規約を変更することがあります。変更後の規約はWebサイト上に掲載した時点で効力を生じます。",
      "6. 準拠法・管轄裁判所\n本規約は日本法に準拠し、名古屋地方裁判所を第一審の専属的合意管轄裁判所とします。",
    ],
  },
  特定商取引法: {
    title: "反社会的勢力に対する基本方針",
    body: [
      "株式会社クラプリックスは、社会の秩序や安全に脅威を与える反社会的勢力に対して、以下の基本方針をもって臨みます。",
      "1. 基本姿勢\n当社は、反社会的勢力との一切の関係を遮断し、不当要求に対しては組織全体で毅然とした態度で対応します。",
      "2. 取引の拒絶\n反社会的勢力との取引関係およびビジネス上の関係は、一切持ちません。",
      "3. 有事の対応\n反社会的勢力による不当要求が発生した場合は、速やかに警察・弁護士等の外部専門機関と連携し、法的手段を含む断固とした対応を取ります。",
      "4. 資金提供の禁止\n反社会的勢力に対して、不当要求に応じた資金提供や便宜供与は一切行いません。",
      "5. 担当者の保護\n不当要求への対応にあたる担当者の安全確保に努めます。",
    ],
  },
};

function LegalModal({ label, onClose }: { label: string; onClose: () => void }) {
  const content = legalContents[label];
  if (!content) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8"
      style={{ background: "rgba(0,0,0,0.75)" }}
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-2xl max-h-[80vh] overflow-y-auto"
        style={{ background: "#ffffff", border: "1px solid rgba(0,0,0,0.1)" }}
        onClick={e => e.stopPropagation()}
      >
        <div
          className="sticky top-0 flex items-center justify-between px-6 py-5"
          style={{ background: "#ffffff", borderBottom: "1px solid rgba(0,0,0,0.08)" }}
        >
          <div>
            <p style={{ fontFamily: "'Barlow', sans-serif", fontSize: "10px", letterSpacing: "0.4em", color: "#c00000", marginBottom: "4px" }}>LEGAL</p>
            <h3 style={{ fontFamily: "'Noto Sans JP', sans-serif", fontSize: "16px", fontWeight: 700, color: "#111111" }}>{content.title}</h3>
          </div>
          <button
            onClick={onClose}
            className="w-9 h-9 flex items-center justify-center cursor-pointer transition-all duration-200"
            style={{ background: "rgba(0,0,0,0.04)", border: "1px solid rgba(0,0,0,0.1)", color: "#111111" }}
            onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.background = "#c00000"; (e.currentTarget as HTMLButtonElement).style.color = "#fff"; }}
            onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.background = "rgba(0,0,0,0.04)"; (e.currentTarget as HTMLButtonElement).style.color = "#111111"; }}
          >
            <i className="ri-close-line text-base" />
          </button>
        </div>
        <div className="px-6 py-6 flex flex-col gap-5">
          {content.body.map((p, i) => (
            <p key={i} style={{ fontFamily: "'Noto Sans JP', sans-serif", fontSize: "13px", color: "#111111", lineHeight: 2.1, whiteSpace: "pre-line" }}>{p}</p>
          ))}
        </div>
        <div className="px-6 py-4 flex justify-end" style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}>
          <button
            onClick={onClose}
            className="px-6 py-2 cursor-pointer whitespace-nowrap"
            style={{ background: "rgba(0,0,0,0.04)", border: "1px solid rgba(0,0,0,0.12)", color: "#111111", fontFamily: "'Noto Sans JP', sans-serif", fontSize: "12px" }}
          >
            閉じる
          </button>
        </div>
      </div>
    </div>
  );
}

export default function HomeFooter() {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState<string | null>(null);
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);

  const toggleAccordion = (key: string) => {
    setOpenAccordion(prev => (prev === key ? null : key));
  };

  return (
    <footer style={{ background: "#ffffff", color: "#111111" }}>
      {openModal && <LegalModal label={openModal} onClose={() => setOpenModal(null)} />}

      {/* Diagonal decorative lines */}
      <DiagonalLines variant="gold" intensity="light" />

      {/* ── CTA BAND ── */}
      <div style={{ background: "#ffffff", borderTop: "1px solid #e8e8e8" }}>
        <div className="px-5 md:px-12 lg:px-20 py-16 md:py-24 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <p style={{ fontFamily: "'Barlow', sans-serif", fontSize: "11px", letterSpacing: "0.35em", color: "#c00000", marginBottom: "10px" }}>
              FREE CONSULTATION
            </p>
            <h2 style={{ fontFamily: "'Noto Sans JP', sans-serif", fontSize: "22px", fontWeight: 700, color: "#111111", lineHeight: 1.6 }}>
              あなたのビジネスの隣に立つ<br />
              共に前へ
            </h2>
            <p style={{ fontFamily: "'Noto Sans JP', sans-serif", fontSize: "14px", color: "#111111", marginTop: "8px", lineHeight: 1.8 }}>
              デジタルマーケティングを一気通貫でサポート。
            </p>
          </div>

        </div>
      </div>

      {/* ── MAIN FOOTER ── */}
      <div style={{ borderTop: "1px solid rgba(0,0,0,0.06)" }}>

        {/* Desktop: logo + nav grid */}
        <div className="hidden md:block px-12 lg:px-20 pt-16 pb-10">
          <div className="flex gap-16 mb-14">
            {/* Logo block */}
            <div className="shrink-0 w-[200px]">
              <button
                onClick={() => navigate("/")}
                className="cursor-pointer focus:outline-none mb-5 block"
                style={{ background: "none", border: "none", padding: 0 }}
              >
                <span style={{ fontFamily: "'Barlow', sans-serif", fontWeight: 700, fontSize: "24px", letterSpacing: "0.2em", color: "#111111" }}>CRUPLIX</span>
              </button>
              <p style={{ fontFamily: "'Noto Sans JP', sans-serif", fontSize: "12px", color: "#111111", lineHeight: 2.2 }}>
                <span style={{ fontSize: "12px", letterSpacing: "0.12px" }}>
                  株式会社クラプリックスは、Web制作・SEO・MEO・LLMO・広告運用・アプリ開発など、デジタルマーケティング全般を一気通貫でサポートする会社です。
                </span>
              </p>
            </div>

            {/* Nav grid */}
            <div className="flex-1 grid grid-cols-6 gap-8">
              {footerNav.map((col) => (
                <div key={col.en}>
                  <p style={{ fontFamily: "'Barlow', sans-serif", fontSize: "10px", letterSpacing: "0.3em", color: "#111111", marginBottom: "18px" }}>
                    {col.en}
                  </p>
                  <ul className="flex flex-col gap-3">
                    {col.items.map((item) => (
                      <li key={item.label}>
                        <button
                          onClick={() => navigate(item.path)}
                          className="cursor-pointer transition-colors duration-200 text-left"
                          style={{ background: "none", border: "none", padding: 0 }}
                          onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.color = "#c00000"; }}
                          onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.color = "#111111"; }}
                        >
                          <span style={{ fontFamily: "'Noto Sans JP', sans-serif", fontSize: "12px", color: "#111111", letterSpacing: "0.02em", whiteSpace: "nowrap" }}>
                            {item.label}
                          </span>
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Mobile: logo + accordion nav */}
        <div className="md:hidden">
          {/* Logo */}
          <div className="px-5 pt-10 pb-6" style={{ borderBottom: "1px solid rgba(0,0,0,0.06)" }}>
            <button
              onClick={() => navigate("/")}
              className="cursor-pointer focus:outline-none"
              style={{ background: "none", border: "none", padding: 0 }}
            >
              <span style={{ fontFamily: "'Barlow', sans-serif", fontWeight: 700, fontSize: "22px", letterSpacing: "0.2em", color: "#111111" }}>CRUPLIX</span>
            </button>
            <p className="mt-3" style={{ fontFamily: "'Noto Sans JP', sans-serif", fontSize: "12px", color: "#111111", lineHeight: 1.8 }}>
              株式会社クラプリックスは、Web制作・SEO・MEO・LLMO・広告運用・アプリ開発など、デジタルマーケティング全般を一気通貫でサポートする会社です。
            </p>
          </div>

          {/* Accordion nav */}
          {footerNav.map((col) => {
            const isOpen = openAccordion === col.en;
            return (
              <div key={col.en} style={{ borderBottom: "1px solid rgba(0,0,0,0.07)" }}>
                <button
                  onClick={() => toggleAccordion(col.en)}
                  className="w-full flex items-center justify-between cursor-pointer focus:outline-none"
                  style={{ padding: "0 20px", background: "none", border: "none", height: "48px" }}
                >
                  <div className="flex items-center gap-0" style={{ position: "relative", paddingLeft: "14px" }}>
                    {/* 左縦線アクセント */}
                    <span
                      style={{
                        position: "absolute",
                        left: 0,
                        top: "50%",
                        transform: "translateY(-50%)",
                        width: "2px",
                        height: isOpen ? "32px" : "20px",
                        background: isOpen ? "#c00000" : "rgba(0,0,0,0.15)",
                        transition: "height 0.25s ease, background 0.25s ease",
                        borderRadius: "1px",
                      }}
                    />
                    <div className="flex flex-col items-start" style={{ gap: "2px" }}>
                      <span
                        style={{
                          fontFamily: "'Barlow', sans-serif",
                          fontSize: "9px",
                          letterSpacing: "0.3em",
                          color: isOpen ? "#c00000" : "#111111",
                          transition: "color 0.25s",
                          lineHeight: 1,
                        }}
                      >
                        {col.en}
                      </span>
                      <span
                        style={{
                          fontFamily: "'Noto Sans JP', sans-serif",
                          fontSize: "12px",
                          fontWeight: isOpen ? 700 : 400,
                          color: isOpen ? "#111111" : "#111111",
                          transition: "color 0.25s, font-weight 0.25s",
                          letterSpacing: "0.04em",
                          lineHeight: 1.3,
                        }}
                      >
                        {col.ja}
                      </span>
                    </div>
                  </div>
                  {/* +/- アイコン */}
                  <span
                    style={{
                      width: "28px",
                      height: "28px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: `1px solid ${isOpen ? "#c00000" : "rgba(0,0,0,0.12)"}`,
                      borderRadius: "50%",
                      color: isOpen ? "#c00000" : "rgba(0,0,0,0.3)",
                      fontSize: "14px",
                      transition: "border-color 0.25s, color 0.25s, transform 0.3s ease",
                      transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
                      flexShrink: 0,
                    }}
                  >
                    <i className="ri-add-line" />
                  </span>
                </button>

                {/* Accordion content */}
                <div
                  style={{
                    maxHeight: isOpen ? `${col.items.length * 50}px` : "0px",
                    overflow: "hidden",
                    transition: "max-height 0.4s cubic-bezier(0.22,1,0.36,1)",
                  }}
                >
                  <ul style={{ padding: "0 20px 16px 28px" }}>
                    {col.items.map((item) => (
                      <li key={item.label}>
                        <button
                          onClick={() => navigate(item.path)}
                          className="w-full flex items-center justify-between cursor-pointer focus:outline-none group"
                          style={{ padding: "12px 0", background: "none", border: "none", borderBottom: "1px solid rgba(0,0,0,0.06)" }}
                          onMouseEnter={e => {
                            const span = (e.currentTarget as HTMLButtonElement).querySelector("span");
                            if (span) (span as HTMLElement).style.color = "#c00000";
                          }}
                          onMouseLeave={e => {
                            const span = (e.currentTarget as HTMLButtonElement).querySelector("span");
                            if (span) (span as HTMLElement).style.color = "#111111";
                          }}
                        >
                          <span
                            style={{
                              fontFamily: "'Noto Sans JP', sans-serif",
                              fontSize: "13px",
                              color: "#111111",
                              letterSpacing: "0.03em",
                              transition: "color 0.2s",
                              textAlign: "left",
                            }}
                          >
                            {item.label}
                          </span>
                          <i
                            className="ri-arrow-right-line"
                            style={{ color: "#111111", fontSize: "13px", flexShrink: 0 }}
                          />
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>

        {/* ── BOTTOM BAR ── */}
        <div
          className="px-5 md:px-12 lg:px-20 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4"
          style={{ borderTop: "1px solid rgba(0,0,0,0.06)" }}
        >
          <div className="flex flex-wrap gap-5">
            {["プライバシーポリシー", "利用規約", "特定商取引法"].map((label) => (
              <button
                key={label}
                onClick={() => setOpenModal(label)}
                className="cursor-pointer transition-colors duration-200"
                style={{ fontFamily: "'Noto Sans JP', sans-serif", fontSize: "12px", color: "#111111", background: "none", border: "none", padding: 0 }}
                onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.color = "#111111"; }}
                onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.color = "#111111"; }}
              >
                {label}
              </button>
            ))}
          </div>
          <p style={{ fontFamily: "'DM Mono', monospace", fontSize: "11px", letterSpacing: "0.15em", color: "#111111" }}>
            Copyright &copy; 2025 株式会社クラプリックス. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
